import { atom } from 'recoil'
import { CoursePageLink } from 'types'

export const pageHeaderAtom = atom({
  key: 'pageHeader',
  default: {
    title: '',
    titlePrefix: '',
    backLinkHref: '',
    backLinkText: '',
    loading: true,
    pages: [] as CoursePageLink[],
    courseHasAssessments: true,
  },
})
